import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import DrawerSelect from "@/components/DrawerSelect/DrawerSelect";
import { getCities } from "@/pages/price-offer/price-offer-helper";
import { Else } from "@componentsShared/Conditional/Else";
import { DialogSelect } from "@/components/DialogSelect";
import { useTranslation } from "@i18n";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import useIsMobile from "@hooks/useIsMobile";
import { useMemo, useState } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import { searchCities } from "@/pages/sell-my-car/utils/citySearchHelper";
var ChangeCityModal = function ChangeCityModal() {
  var _state$draftOrder3, _state$draftOrder3$cu, _state$draftOrder3$cu2;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var isMobile = useIsMobile();
  var _useState = useState(null),
    selectedCity = _useState[0],
    setSelectedCity = _useState[1];
  var lang = useLang();
  var handleCityChange = function handleCityChange(city) {
    var _state$draftOrder;
    if (!city) return;
    setSelectedCity(city);

    // Prepare inspection location data for API request
    var inspectionLocationData = {
      cityId: city.id,
      cityName: lang === "ar" ? city.name_ar : city.name_en,
      cityNameAr: city.name_ar,
      cityNameEn: city.name_en
    };

    // Update the context with the new city data
    actions.setInspectionLocation(inspectionLocationData);

    // Update the current step data to trigger re-calculation of checkCityAllowedForInspection
    if (state !== null && state !== void 0 && (_state$draftOrder = state.draftOrder) !== null && _state$draftOrder !== void 0 && _state$draftOrder.currentStep) {
      var updatedCurrentStep = _objectSpread(_objectSpread({}, state.draftOrder.currentStep), {}, {
        data: _objectSpread(_objectSpread({}, state.draftOrder.currentStep.data), {}, {
          city_id: city.id,
          // Update city_id to trigger checkCityAllowedForInspection recalculation
          city_name: city.name_ar // Update with Arabic name to match the lookup
        })
      });
      actions.setStepNavigation(state.draftOrder.previousStep, updatedCurrentStep);
    }
  };

  // Get all approved cities
  var cities = useMemo(function () {
    return getCities().filter(function (city) {
      var _state$draftOrder2, _state$draftOrder2$cu, _state$draftOrder2$cu2;
      return (city === null || city === void 0 ? void 0 : city.id) !== (state === null || state === void 0 ? void 0 : (_state$draftOrder2 = state.draftOrder) === null || _state$draftOrder2 === void 0 ? void 0 : (_state$draftOrder2$cu = _state$draftOrder2.currentStep) === null || _state$draftOrder2$cu === void 0 ? void 0 : (_state$draftOrder2$cu2 = _state$draftOrder2$cu.data) === null || _state$draftOrder2$cu2 === void 0 ? void 0 : _state$draftOrder2$cu2.city_id);
    });
  }, []);

  // Get display name for city
  var getCityDisplayName = function getCityDisplayName(city) {
    return lang === "ar" ? city.name_ar : city.name_en;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pt-3 pb-2.5 rounded-br-lg rounded-bl-lg bg-blue-alice px-3 flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--info-outline-rounded",
    width: 4,
    height: 4,
    className: "text-gray-text"
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-black-primary text-xs font-normal flex items-center gap-px"
  }, tShort("sell_trade_v2/area_not_available", {
    ns: "web_sell_trade"
  }), /*#__PURE__*/React.createElement("span", null, state === null || state === void 0 ? void 0 : (_state$draftOrder3 = state.draftOrder) === null || _state$draftOrder3 === void 0 ? void 0 : (_state$draftOrder3$cu = _state$draftOrder3.currentStep) === null || _state$draftOrder3$cu === void 0 ? void 0 : (_state$draftOrder3$cu2 = _state$draftOrder3$cu.data) === null || _state$draftOrder3$cu2 === void 0 ? void 0 : _state$draftOrder3$cu2.city_name))), /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(DrawerSelect, {
    value: selectedCity,
    haveTrigger: false,
    onChange: handleCityChange,
    renderTrigger: function renderTrigger(_ref) {
      var openDrawer = _ref.openDrawer;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
        className: "font-semibold text-xs text-primary underline",
        onClick: function onClick() {
          return openDrawer();
        }
      }, tShort("sell_trade_v2/change_city", {
        ns: "web_sell_trade"
      })));
    },
    options: cities,
    searchFunction: searchCities,
    getDisplayName: getCityDisplayName,
    placeholder: tShort("sell_trade_v2/change_city", {
      ns: "web_sell_trade"
    }),
    searchPlaceholder: tShort("sell_trade_v2/search_city", {
      ns: "web_sell_trade"
    }),
    drawerTitle: tShort("sell_trade_v2/select_city_title", {
      ns: "web_sell_trade"
    }),
    allowClear: false,
    limit: 50,
    className: "text-primary-new underline cursor-pointer text-xs font-semibold !border-0 !bg-transparent !p-0 !h-auto !rounded-none"
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(DialogSelect, {
    value: selectedCity,
    onChange: handleCityChange,
    options: cities,
    searchFunction: searchCities,
    getDisplayName: getCityDisplayName,
    placeholder: tShort("sell_trade_v2/change_city", {
      ns: "web_sell_trade"
    }),
    searchPlaceholder: tShort("sell_trade_v2/search_city", {
      ns: "web_sell_trade"
    }),
    dialogTitle: tShort("sell_trade_v2/select_city_title", {
      ns: "web_sell_trade"
    }),
    allowClear: false,
    limit: 50,
    className: "text-primary-new underline cursor-pointer text-xs font-semibold !border-0 !bg-transparent !p-0 !h-auto !rounded-none",
    renderTrigger: function renderTrigger(_ref2) {
      var openDrawer = _ref2.openDrawer;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
        className: "font-semibold text-xs text-primary-new underline",
        onClick: function onClick() {
          return openDrawer();
        }
      }, tShort("sell_trade_v2/change_city", {
        ns: "web_sell_trade"
      })));
    }
  })))));
};
export default ChangeCityModal;